import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ProjectCard = makeShortcode("ProjectCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Projects`}</h2>
    <ProjectCard title="Todo App" link="#" bg="linear-gradient(to right, #00afff 0%, #00ffbf 100%)" mdxType="ProjectCard">
This is TODO Application built with React js, React Bootstrap 4 and It was awesome UI.
    </ProjectCard>
    <ProjectCard title="Unitech Loans" link="https://unitecloans.com/" bg="linear-gradient(to right, #00afff 0%, #00ffbf 100%)" mdxType="ProjectCard">
This is Loans Provide Website/Portel built with HTML5,CSS3,JAVASCRIPT,JQUERY and this projects all front-end design by me  .
    </ProjectCard>
    <ProjectCard title="Dania Medical Service" link="https://www.daniamedicalservices.com/" bg="linear-gradient(to right, #00afff 0%, #00ffbf 100%)" mdxType="ProjectCard">
This is Medical Service Provide Website built with HTML5,CSS3,JAVASCRIPT,JQUERY and this projects all front-end design by me .
    </ProjectCard>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      